<template>
  <GoogleMap
    v-if="loaded"
    class="max-w-screen-lg"
    api-key="AIzaSyAA7zA7arWH7LrdcxNUzwhNTasjmnMZb-w"
    style="width: 100%; height: 500px"
    :center="{ lat: 39.8097343, lng: -98.5556199 }"
    :zoom="4"
    map-type-id="terrain"
  >
    <Marker
      v-for="(m, index) in markers"
      :key="index"
      :options="{
        position: { lat: parseFloat(m.lat), lng: parseFloat(m.lng) },
        icon: getMarkerIcon(m),
      }"
    >
      <InfoWindow>
        <div class="p-3">
          <a class="text-indigo-600" :href="`/admin/teams/${m.id}`" target="_blank">
            {{ m.company }}
          </a>
          <p class="mt-2">$ per Candidate: ${{ m.cost_per_candidate }}</p>
          <p class="mt-2">$ per Hire: ${{ m.cost_per_hire }}</p>
        </div>
      </InfoWindow>
    </Marker>
  </GoogleMap>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { GoogleMap, Marker, InfoWindow } from 'vue3-google-map';

const store = useStore();
const markers = ref([]);
const loaded = ref(false);

const getTeams = async () => {
  store.commit('general/showLoadingSpinner');
  const response = await fetch(`/api/admin/teams/team_map`);
  const data = await response.json();
  markers.value = data.records;
  loaded.value = true;
  store.commit('general/hideLoadingSpinner');
};

const getMarkerIcon = marker => {
  if (marker.active_customer) {
    return marker.cost_per_candidate >= 250
      ? 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
      : 'https://maps.google.com/mapfiles/ms/icons/green-dot.png';
  }
  return 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';
};

onMounted(async () => {
  await getTeams();
});
</script>
